import styled from '@emotion/styled';
import { NafThemeType, breakpoints, spacing } from '@naf/theme';
import { themeLight } from '@lib/nafTheme';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';

export const ScrollContainer = styled.div`
  padding-top: ${spacing.space24};
  display: flex;
  align-items: center;
  gap: ${spacing.space4};

  @media (max-width: ${breakpoints.l}) {
    display: none;
  }
`;

const BaseScrollButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    borderRadius: '40px !important',
    width: theme.spacing(10),
    height: theme.spacing(10),
    padding: 0,
    justifyContent: 'center',
  },
  svg: {
    marginBottom: theme.spacing(0.5),
  },
}));

export const BackScrollButton = simbaStyled(BaseScrollButton)(({ theme }) => ({
  '&&': {
    marginRight: theme.spacing(5),
  },
}));

export const ForwardScrollButton = simbaStyled(BaseScrollButton)(({ theme }) => ({
  '&&': {
    marginLeft: theme.spacing(5),
  },
}));

export const Dot = styled.div<{ $inView: boolean }>`
  width: ${spacing.space8};
  height: ${spacing.space8};
  border-radius: 40px;
  flex-shrink: 0;
  background: ${({ theme, $inView }) => {
    const activeTheme: NafThemeType = theme.componentColors ? theme : themeLight;
    return $inView ? activeTheme.componentColors.navigation.active : activeTheme.componentColors.navigation.inactive;
  }};
`;
